exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.c-grid-check-column[data-v-6c238bed] {\n  display: none;\n}\n", ""]);

// exports
